import React from 'react';
import { EntryPointContainer, type EntryPoint, type EntryPointComponent } from 'react-relay';
import { REDIRECT } from '@atlassian/jira-entry-point-page-layout-fields/src/index.tsx';
import { usePageLayoutEntryPoint } from '@atlassian/jira-entry-point-page-layout/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { EntryPointReferencePlaceholder } from '@atlassian/jira-entry-point-placeholder';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

export const RedirectEntrypointContainer = (): React.JSX.Element | null => {
	const redirectEntrypointRef =
		usePageLayoutEntryPoint<
			EntryPoint<
				EntryPointComponent<{}, {}, {}, { fallback: () => JSX.Element | undefined }>,
				{ fallback: () => JSX.Element | undefined }
			>
		>(REDIRECT);

	if (!redirectEntrypointRef) return null;

	return (
		<UFOSegment name="redirect-entrypoint">
			<JSErrorBoundary fallback="unmount" id="redirect-entrypoint" packageName="page-container">
				<EntryPointReferencePlaceholder
					name="redirect-entrypoint"
					fallback={null}
					entryPointReference={redirectEntrypointRef}
				>
					<EntryPointContainer entryPointReference={redirectEntrypointRef} props={{}} />
				</EntryPointReferencePlaceholder>
			</JSErrorBoundary>
		</UFOSegment>
	);
};
